<template>
  <div class="app">
    <div class="app-body">
      <main class="main">
        <div class="container-fluid">
          <div class="b2b-investigation">
            <h1><i class="fa fa-truck" aria-hidden="true"></i></h1>
            <h1>B2B Investigation Dashboard</h1>
          </div>
        </div>
      </main>
    </div>
  </div>
</template>

<style scoped>
main{
  margin: 0 !important;
}
h1{
  text-align: center;
    margin: auto;
    display: block;
    color: #00000030;
    font-weight: 700;
}
i.fa.fa-truck {
    font-size: 168px;
}
</style>


<script>
//import nav from '../_nav'
import { Header as AppHeader, Sidebar, Aside as AppAside, Footer as AppFooter, Breadcrumb } from '../components/'
import CryptoJS from 'crypto-js';
import axios from 'axios';
import apiUrl from '../constants';

export default {
  name: 'b2b',
  components: {
    AppHeader,
    Sidebar,
    AppAside,
    AppFooter,
    Breadcrumb
  },
  data () {
    return {
  //    nav: nav.items
        mapping: {},
        GetMappingObj: {}
    }
  },
  created(){
  },
  mounted(){
    
  },
  computed: {
    name () {
      return this.$route.name
    },
    list () {
      let t2 = new Date().setHours(new Date().getHours());
      if(window.localStorage.getItem('logoutTime') && window.localStorage.getItem('logoutTime') < t2){
        this.logout();
      }else{
        return this.$route.matched
      }
    }
  },
  methods: {
  logout() {
       localStorage.clear();
       localStorage.removeItem('accesshubdata')
       localStorage.removeItem('accesspermissiondata')
       localStorage.removeItem('accessuserdata')
       localStorage.removeItem('accessuserToken')
       localStorage.removeItem('isLoggedIn')
       localStorage.removeItem('logoutTime')
       localStorage.removeItem('accessrole')
       this.$router.push('/login');

   },
  }
}
</script>



// WEBPACK FOOTER //
// src/containers/b2b.vue?2f0db202